export default __webpack_public_path__ + "static/media/logo_bestgolf_bianco_b2b.dc143bae.png";